// joinNode.js - Joins multiple inputs into one output

import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const JoinNode = ({ id, data }) => {
  const handles = [
    { id: 'input1', type: 'target', position: Position.Left, top: 25 },
    { id: 'input2', type: 'target', position: Position.Left, top: 50 },
    { id: 'input3', type: 'target', position: Position.Left, top: 75 },
    { id: 'output', type: 'source', position: Position.Right }
  ];

  return (
    <BaseNode
      id={id}
      data={data}
      title="Join"
      description="Combine 3 inputs"
      handleConfig={handles}
      width={180}
      height={160}
    />
  );
};
